/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useDispatch } from 'react-redux';
import { Grid, GridColumn } from 'semantic-ui-react';
import IconLoginTheme from 'Assets/images/logintheme.jpg';
import { iamDoctorLogin } from 'Redux/modules/auth/actions';
import { EmailPasswordBody } from 'Types';
import CustomModal from 'Modules/CustomModal/CustomModal';

import { OtpMethod } from './constants';
import Otp from './Otp';
import styles from './Login.less';
import PasswordEmail from './PasswordEmail';

export interface Status {
  loading: boolean;
  error: string | null;
}

export interface OtpData {
  loading: boolean;
  target: string;
}

const Login = () => {
  const dispatch = useDispatch();
  const [checkingEmailPassword, setCheckingEmailPassword] = useState(true);
  const [otpData, setOtpData] = useState<OtpData>({
    loading: false,
    target: '',
  });
  const [emailPasswordStatus, setEmailPasswordStatus] = useState<Status>({
    loading: false,
    error: null,
  });
  const [otpMethod, setOtpMethod] = useState(OtpMethod.SMS);

  const login = async (loginFormValues: EmailPasswordBody) => {
    setEmailPasswordStatus({
      ...emailPasswordStatus,
      loading: true,
    });
    try {
      const payload = { ...loginFormValues, otpMethod };
      const res = await dispatch(iamDoctorLogin(payload));
      setCheckingEmailPassword(false);
      setOtpData(prevState => ({
        ...prevState,
        target: res.data?.target || '',
      }));
    } catch (errorRes: any) {
      setEmailPasswordStatus((prevState: Status) => ({
        ...prevState,
        error: errorRes?.data?.message,
      }));
    } finally {
      setEmailPasswordStatus((prevState: Status) => ({
        ...prevState,
        loading: false,
      }));
    }
  };

  return (
    <div id="main" className={styles.wrapper}>
      <Helmet title="Login" />
      <Grid textAlign="center" verticalAlign="middle">
        <GridColumn style={{ maxWidth: '980px' }}>
          <div className={styles.loginWrap}>
            <div className={styles.loginContent}>
              {checkingEmailPassword ? (
                <PasswordEmail
                  statusLogin={emailPasswordStatus}
                  onSubmit={login}
                  otpMethod={otpMethod}
                  setOtpMethod={setOtpMethod}
                />
              ) : (
                <Otp
                  otpData={otpData}
                  setOtpData={setOtpData}
                  currentMethod={otpMethod}
                  setCurrentMethod={setOtpMethod}
                />
              )}
            </div>
            <div className={styles.loginBg}>
              <div className={styles.connecting}>CONNECTING YOU WITH</div>
              <div className={styles.yourPatient}>YOUR PATIENTS</div>
              <img src={IconLoginTheme} alt="login theme" />
            </div>
          </div>
        </GridColumn>
      </Grid>
      <CustomModal />
    </div>
  );
};

export default Login;
